import React from 'react';
import { useSearchkit, useSearchkitVariables } from '@searchkit/client';
import { useTranslation } from 'react-i18next';

import {
  FormSelect,
  FormikWrapper,
} from '@uncinc/uncinc-react-kitchen-sink';

const useInitialValues = () => {
  const parsed = useSearchkitVariables();
  const filters = {};

  if (parsed.filters) {
    parsed.filters.forEach((filter) => {
      switch (filter.identifier) {
        case 'combined_type':
          filters['combined_type'] = filter.value;
          break;

        default:
          break;
      }
    });
  }

  return filters;
};

export const SelectFacet = ({ facet }) => {
  const { t } = useTranslation();
  const api = useSearchkit();

  const options = facet.entries.map((entry) => ({ value: entry.label, label: t(`facets.${facet.identifier}.${entry.label}`) }));
  const initialValues = useInitialValues();

  return (
    <div className="Facet SelectFacet" key={facet.identifier}>
      <FormikWrapper initialValues={initialValues}>
        <FormSelect
          title={facet.label}
          required
          placeholder={t('general.select_a_value')}
          fieldName={facet.identifier}
          options={options}
          onChange={(value) => {
            api.removeFiltersByIdentifier(facet.identifier);
            if (value) {
              api.addFilter({ identifier: facet.identifier, value: value });
            }
            api.search();
          }}
        />
      </FormikWrapper>
    </div>
  );
};
SelectFacet.DISPLAY = 'SelectFacet';
